import favicon from 'assets/img/themes/kinto/favicon.ico';
import background from 'assets/img/themes/kinto/background.jpg';
import logo from 'assets/img/themes/kinto/logo.png';
import sidebarLogo from 'assets/img/themes/kinto/logo-sidebar.png';
import collapsed from 'assets/img/themes/kinto/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '156px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'KINTO',
    favicon: favicon,
    support: 'KINTO Support',
  },
  footer: {
    url: '',
    copyright: '',
    contactus: '',
    version: true,
  },
};
